<template>

  <list-view-page v-if='request.resourceId' title='Appointment Types' groupByField='practitioner' :list-item='li'
    :card-item='card' :attrs='attrs' :touch='touch' :with-add='true' :request.sync='request' @input="touch++"
    @new='quickAdd=true' @selected='performEdit' @edit='performEdit'>
    <template v-if='quickAdd'>
      <!-- :space-id='selectedSpaceId' -->
      <quick-appointment-type-form :space-id='spaceId' :practitioner-id='practitionerId' @input="productAdded"
        @close="quickAdd=false" />
    </template>

    <template slot='title-right'>
      <v-tabs v-model='activeTab' class='mb-0'>

        <template v-if="member && (member.user || member.id)">
          <v-tab>
            <v-avatar :size="32" v-if="member.profile_picture" class="mr-3">
              <v-img :src="member.profile_picture" />
            </v-avatar>
            <template v-if="member.user">{{member.user.first_name}} {{member.user.last_name}}</template>
            <span v-else v-text="member.full_name" />
          </v-tab>
        </template>
        <template v-else>
          <v-tab v-for='(member, index) in members' :key='index' @click='setPractitioner(member)'>
            <v-avatar :size="32" v-if="member.profile_picture" class="mr-3">
              <v-img :src="member.profile_picture" />
            </v-avatar>
            {{ member.full_name }}
          </v-tab>
        </template>
        <v-spacer />
        <v-switch v-model='showArchived' dense label='Show archived' class='mb-2 mr-2' />
      </v-tabs>
    </template>

    <template slot='group-title' slot-scope="props">
      <v-card flat class='mb-3'>
        <v-card-title class='grey lighten-4 caption py-1' v-if='props.item && props.item.practitioner'>
          <template v-if='getPractitionerById(props.item.practitioner)'>
            {{ getPractitionerById(props.item.practitioner).full_name }}'s
          </template>
          appointment types
          <template v-if='spaceName'>for {{spaceName}}</template>
          <v-spacer />

          <!-- copy products -->
          <template v-if="props.item.practitioner">
            <v-btn @click='dialogs.copyProducts=true' color="primary" class="mr-10" outlined small>Copy</v-btn>
          </template>
        </v-card-title>

        <v-divider />
        <v-btn small fab absolute bottom right @click='quickAdd=true'>
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-card>
    </template>

    <template slot='empty-text'>
      <v-list-item slot='empty-text'>
        <v-list-item-content>
          <v-list-item-title>
            No items found for {{practitioner.full_name}}
            <span v-if='spaceName'>in {{spaceName}}</span>
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn outlined small @click='dialogs.copyProducts=true' color='primary'>
            Copy appointment types</v-btn>
        </v-list-item-action>
        <v-list-item-action>
          <v-btn outlined small @click='quickAdd=true' color='primary'>
            <v-icon small>mdi-plus</v-icon>
            New
          </v-btn>
        </v-list-item-action>
        <!--
      <v-list-item-action >
        <v-btn @click='get' outlined small color='primary' >Refresh</v-btn>
      </v-list-item-action> -->
      </v-list-item>
    </template>

    <!-- dialogs -->
    <v-dialog v-model="dialogs.copyProducts">
      <v-card v-if="dialogs.copyProducts">
        <v-card-title class='subtitle-1 overline py-1 grey lighten-4'>
          Copy products onto {{ practitioner.full_name }}'s profile
          <v-spacer />
          <v-btn icon @click="dialogs.copyProducts=false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />

        <copy-products
          :practitioner-id="practitionerId"
          :space-id="spaceId"
          @success="dialogs.copyProducts=false;touch++" />
      </v-card>
    </v-dialog>

  </list-view-page>

</template>
<script>
import ListViewPage from '@/components/layouts/ListViewPage.vue'
import AppointmentTypeListItem from '@/components/listitems/AppointmentTypeListItem.vue'
import AppointmentTypeCardListItem from '@/components/listitems/AppointmentTypeCardListItem.vue'
import QuickAppointmentTypeForm from '@/components/actions/forms/QuickAppointmentTypeForm.vue'
import CopyProducts from '@/components/actions/CopyProducts.vue'
// import PractitionerPicker from '@/components/pickers/PractitionerPicker.vue'
// import PractitionerListItem from '@/components/listitems/PractitionerListItem.vue'
// import PractitionerChip from '@/components/listitems/PractitionerChip.vue'
import {mapGetters} from 'vuex'
import Vue from 'vue'

export default {
  name: 'AppointmentTypesPage',
  components: {
    ListViewPage,
    QuickAppointmentTypeForm,
    CopyProducts
    // PractitionerPicker,
    // PractitionerChip
  },
  props: {
    spaceId: { required: true },
    member: { required: false }
  },
  data () {
    return {
      activeTab: null,
      showArchived: false,
      quickAdd: false,
      li: AppointmentTypeListItem,
      card: AppointmentTypeCardListItem,
      request: {
        resource: 'ag.spaces',
        extra: 'appointment-types',
        params: {
          'ordering': 'practitioner,order,title',
          'archived': 'False'
        }
      },
      dialogs: {
        copyProducts: false
      },
      touch: 0,
      practitioner: {},
      attrs: {}
    }
  },
  watch: {
    spaceId: {
      immediate: true,
      handler () {
        if (this.spaceId) {
          Vue.set(this.request, 'resourceId', this.spaceId)
          this.touch++
        }
      }
    },
    memberId: {
      immediate: true,
      handler () {
        if (this.member) {
          this.setPractitioner(this.member)
        }
      }
    },
    practitionerId: {
      immediate: true,
      handler () {
        if (this.practitionerId) {
          Vue.set(this.request.params, 'practitioner', this.practitionerId)
          this.touch++
        }
      }
    },
    touchId () {
      this.touch++
    },
    showArchived () {
      if (this.showArchived === true && ('archived' in this.request.params)) {
        delete this.request.params['archived']
      } else {
        this.request.params['archived'] = 'False'
      }
      this.touch++
    },
    members: {
      immediate: true,
      handler () {
        if (this.members && this.members.length > 0) {
          if (!this.practitionerId) {
            this.setPractitioner(this.members[0])
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters('identity', ['getSpaceById', 'getPractitionerById', 'getMembers']),
    space () {
      return this.getSpaceById(this.spaceId)
    },
    members () {
      if (this.spaceId) {
        let members = this.getMembers(this.spaceId)
        return members
      }
      return []
    },
    memberId () { return this.getObjectPath(this.member, 'id') },
    practitionerId () {
      let pid = this.getObjectPath(this.practitioner, 'id')
      if (!pid) {
        pid = this.getObjectPath(this.practitioner, 'user.id')
      }
      return pid
    },
    spaceName () {
      return this.getObjectPath(this.space, 'title', '')
    },
    touchId () {
      let atState = this.getObjectPath(this.$store.state.events, 'appointment-type-form.touch')
      let newAtState = this.getObjectPath(this.$store.state.events, 'quick-appointment-type-form.touch')
      return atState + '/' + newAtState
    }
  },
  methods: {
    setPractitioner (practitioner) {
      this.practitioner = practitioner
    },
    performEdit (appointmentType) {
      let title = `${this.spaceName} - ${appointmentType.title}`
      this.launchAppointmentTypeForm(this.spaceId, appointmentType.id, title)
    },
    productAdded (at) {
      this.request.result.results.push(at)
      this.touch++
      this.init()
    }
  }
}
</script>
